import React from 'react';

interface UsersHeaderProps {
  count: number;
  search: string;
  onSearchChange: (value: string) => void;
  onAddUser: () => void;
}

const UsersHeader: React.FC<UsersHeaderProps> = ({ count, search, onSearchChange, onAddUser }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div className="flex items-center gap-3">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">User Management</h1>
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300">{count}</span>
    </div>
    <div className="flex items-center gap-3">
      <div className="relative">
        <svg className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <circle cx="9" cy="9" r="6" />
          <path d="M14 14l4 4" strokeLinecap="round" />
        </svg>
        <input
          type="text"
          aria-label="Search users"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search name or email…"
          className="w-64 max-w-full pl-9 pr-3 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <button type="button" onClick={onAddUser} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md whitespace-nowrap">Add User</button>
    </div>
  </div>
);

export default UsersHeader;
